
import { map, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {Observable, combineLatest, BehaviorSubject} from 'rxjs';
import { PowerForecastParkGQL, PowerForecastPortfolioGQL, ForecastProvidersEnum, IconForecastParkGQL } from '../../graphql';
import { PowerForecast } from 'app/models/monitor/power-forecast.model';
import { ForecastService } from 'app/forecast/services/forecast.service';
import {NavigationDetails} from '../../navigation/navigation.service';

@Injectable()
export class PowerForecastService {

  constructor(
    private powerForecastParkGQL: PowerForecastParkGQL,
    private powerForecastPortfolioGQL: PowerForecastPortfolioGQL,
    private iconForecastParkGQL: IconForecastParkGQL
  ) { }
  public getPowerForecastPortfolioData(rangeHoursObservable: Observable<number>, provider: ForecastProvidersEnum[],
                                       navigationDetails: NavigationDetails): Observable<PowerForecast> {
    return combineLatest([
      rangeHoursObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([rangeHours]) => {
        return this.powerForecastPortfolioGQL.subscribe({
          variables: {
          hours: rangeHours,
          provider,
          portfolioId: navigationDetails.selectedPortfolioId,
          parkIds: navigationDetails.selectedParksIds}
        }).pipe(
          map(result => PowerForecast.mapFromPortfolio(result.data.portfolios[0], rangeHours))
        )}
      )
    );
  }
  public getPowerForecastParkData(rangeHoursObservable: Observable<number>, parkNameObservable: Observable<string>,
                                  provider: ForecastProvidersEnum[],
                                  selectedTurbinesIds: string[]
): Observable<PowerForecast> {
    return combineLatest([
      rangeHoursObservable,
      parkNameObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([rangeHours, parkName]) =>
        this.powerForecastParkGQL.subscribe({
          variables: {
          hours: rangeHours,
          name: parkName,
          provider,
          turbineIds: selectedTurbinesIds
          }
        }).pipe(
          map(result => PowerForecast.mapFromPark(result.data.parks[0], rangeHours))
        )
      )
    );
  }

  public getIconForecastParkData(rangeHoursObservable: Observable<number>, parkNameObservable: Observable<string>,
                                 arrLength: number, selectedTurbinesIds: string[]): Observable<{ icon: string, timestamp: number }[]
      > {
    return combineLatest([
      rangeHoursObservable,
      parkNameObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([rangeHours, parkName]) =>
        this.iconForecastParkGQL.subscribe({
          variables: {
            hours: rangeHours,
            name: parkName,
            turbineIds: selectedTurbinesIds }
        }).pipe(
          map(result => PowerForecast.mapFromIconsPark(result.data.parks[0].forecastDataSeries.icon, rangeHours, arrLength))
        )
      )
    );
  }

}
